import { IntercomBootSettings } from 'types/intercom';

/**
 * Check if Intercom is loaded and available
 */
export const isIntercomAvailable = (): boolean =>
  typeof window !== 'undefined' && typeof window.Intercom === 'function';

/**
 * Initialize Intercom with user data
 * @param userData - User data to boot Intercom with
 */
export const initializeIntercom = (userData?: Partial<IntercomBootSettings>): void => {
  if (!isIntercomAvailable()) {
    console.warn('Intercom is not available');
    return;
  }

  try {
    const bootData: IntercomBootSettings = {
      app_id: 'rq8ghyzs',
      ...userData,
    };

    window.Intercom('boot', bootData);
  } catch (error) {
    console.error('Error initializing Intercom:', error);
  }
};

/**
 * Show the Intercom messenger
 * @param prefilledMessage - Optional prefilled message to show
 * @returns boolean indicating if Intercom was successfully shown
 */
export const showIntercom = (prefilledMessage?: string): boolean => {
  if (!isIntercomAvailable()) return false;

  try {
    if (prefilledMessage) {
      window.Intercom('showNewMessage', prefilledMessage);
    } else {
      window.Intercom('show');
    }
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Hide the Intercom messenger
 */
export const hideIntercom = (): void => {
  if (!isIntercomAvailable()) {
    return;
  }

  try {
    window.Intercom('hide');
  } catch (error) {
    console.error('Error hiding Intercom:', error);
  }
};
